
import { ref, getDatabase } from 'firebase/database';
import { useObjectVal } from 'react-firebase-hooks/database';
import { collection, query, where, getFirestore, getDocs, doc } from 'firebase/firestore';
import { useCollectionDataOnce, useDocumentOnce } from 'react-firebase-hooks/firestore';

// Get the database reference.
const db = getFirestore();

/**
 * Custom hook to use the Master results given an input gender value.
 **/
export function useMaster(sex) {
  const [value, loading, error] = useObjectVal(ref(getDatabase(), `ctrl_data/master_${sex.toLowerCase()}`));

  if (loading) {
    return null;
  }

  if (error !== undefined) {
    console.error(error);
    return null;
  }

  return value;
}

/**
 * There were two different master formats in play. This is to use the remade master
 * data that is now in Firestore rather than realtime db.
 *
 * Use the master hook Luke, use it and run! Run to Dagobah!
 **/
export function useMasterV2(sex) {
  const [value, loading, error] = useDocumentOnce(doc(db, 'master_results', sex.toLowerCase()));
  if (loading || error !== undefined) {
    return null;
  }

  return value.data();
}


/**
 * Get all the organizations from Firebase to use in the select query.
 *
 * useCollectionDataOnce will pull the query in.
 **/
export function useOrganizations() {

  // Create our query
  const collQuery = query(collection(db, 'organizations'));

  // Get the organizations.
  const [values, loading, error, snapshot] = useCollectionDataOnce(collQuery);

  if (loading || error !== undefined) {
    console.error(error)
    return null;
  }

  // Return the docs and their IDs.
  return snapshot.docs.map((doc) => {
    return {
      id: doc.id,
      ...doc.data()
    }
  });
}

/**
 * Hook to get all clients for an organization.
 *
 * Input is the list of client IDs from an organization.
 **/
export function useClients(organizationId) {
  const clientQuery = query(collection(db, 'clients'), where('organization_id', '=', organizationId))
  const [values, loading, error, snapshot] = useCollectionDataOnce(clientQuery);

  if (loading || error !== undefined) {
    return null;
  }

  return values;
}

/**
 * Hook to get all evals for a given client
 **/
export function useEvals(clientId) {
  const subCollRef = query(collection(db, 'clients', clientId, 'evals'));
  const [values, loading, error, snapshot] = useCollectionDataOnce(subCollRef);

  if (loading || error !== undefined) {
    return null;
  }

  // Return the docs and their IDs.
  return snapshot.docs.map((doc) => {
    return {
      id: doc.id,
      ...doc.data()
    }
  });
}
